import application from 'application/application';

import template from './add-processes.template.html';

import controller from './add-processes.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.addProcesses', {
				url: '/cadastrar-processos?n',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Cadastrar processos'
				}
			});

	}]);
